import { render, staticRenderFns } from "./EditingArea.vue?vue&type=template&id=25afac9e&"
import script from "./EditingArea.vue?vue&type=script&lang=js&"
export * from "./EditingArea.vue?vue&type=script&lang=js&"
import style0 from "./EditingArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
